import type { TabAsButton } from "@circleco/compass/components/Tabs";

import { t } from "@/i18n-js/instance";

import { WORKFLOW_TYPE } from "../../constants";

export const WORKFLOW_HISTORY_TAB_VALUES = [
  WORKFLOW_TYPE.DYNAMIC,
  WORKFLOW_TYPE.BULK_ACTION,
  WORKFLOW_TYPE.SCHEDULED,
] as const;

export type WorkflowHistoryTabValue =
  (typeof WORKFLOW_HISTORY_TAB_VALUES)[number];

type WorkflowHistoryTab = TabAsButton & {
  value: WorkflowHistoryTabValue;
};

export const WORKFLOW_HISTORY_TABS: WorkflowHistoryTab[] = [
  {
    value: WORKFLOW_TYPE.DYNAMIC,
    get label() {
      return t("settings.workflows.table.type.automations");
    },
  },
  {
    value: WORKFLOW_TYPE.BULK_ACTION,
    get label() {
      return t("settings.workflows.table.type.bulk_actions");
    },
  },
  {
    value: WORKFLOW_TYPE.SCHEDULED,
    get label() {
      return t("settings.workflows.table.type.scheduled");
    },
  },
];
